<template>
  <header class="navHeader">
    <div>
      <div :disabled="!canPrev">
        <template v-if="prev">
          <router-link :to="{ name: 'negociejaApp', params: { session, step: prev.slug }}">
            <fa :icon="['far', 'arrow-left']" />
          </router-link>
          <p>{{ prev.title }}</p>
        </template>
      </div>
      <div>
        <h3>{{ step }}</h3>
      </div>
      <div :disabled="!canNext">
        <template v-if="next">
          <router-link :to="{ name: 'negociejaApp', params: { session, step: next.slug }}">
            <fa :icon="['far', 'arrow-right']" />
          </router-link>
          <p>{{ next.title }}</p>
        </template>
      </div>
    </div>

    <!-- <p>{{ textComputed }}</p> -->
  </header>
</template>

<script>
export default {
  props: {
    session: { type: String, required: true },
    step: { type: String, required: true },
    prev: { type: Object, default: null },
    next: { type: Object, default: null },
    msg: { type: String, default: null }
  },
  computed: {
    canPrev () {
      return !!(this.prev && this.prev.slug)
    },
    canNext () {
      return !!(this.next && this.next.slug)
    },
    textComputed () {
      return this.msg
    }
  }
}
</script>

<style lang="scss" scoped>
  .navHeader {
    display: block;
    width: 100%;
    padding: $mg_mini $hmg_large 0;
    // height: 95px;

    @media screen and ( max-height: 689px ) {
      padding: 0 $hmg_mid 0;
    }

    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > div {
        flex: 1;
        padding: 0;

        &[disabled] {
          opacity: .5;
          pointer-events: none;
        }
        &:first-child {
          padding-top: $hmg_mini;
        }
        &:last-child {
          text-align: right;
          padding-top: $hmg_mini;
        }
      }
      h3 {
        text-align: center;
        color: $azul-escuro;
        margin: 0;
      }

      a {
        color: $preto-2;
      }
      p {
        color: $preto-2;
        padding: 0; margin: $hmg_mini 0;
      }
    }

    > p {
      text-align: center;
      margin-top: $hmg_mid;
      color: $preto-2
    }
  }
</style>
